import React, { useContext } from "react";
import { FormLayout, Select, TextField } from "@shopify/polaris";
import PropsType from "prop-types";

// import lib
import { baseHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { useLocation, useNavigate } from "react-router-dom";

const MoreFilters = (props) => {
  const { taggedWith, dataToFetch, setDataToFetch, setTaggedWith, selectedFilter, setSelectedFilter } = props;
  const { cms } = useContext(PrivateContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelectChange = (value) => {
    setSelectedFilter(value);
    const listFilter = baseHelper.setQueryParams(location, { list_filter: value });
    navigate(`${location.pathname}?${listFilter}`);
    const filteredObj = baseHelper.queryParamsFromLocation(location);
    setDataToFetch({ ...dataToFetch, ...filteredObj });
  };

  const filterOptions = [{ label: cms("provider.label.filter.name"), value: constant.NAME }];

  const handleTaggedWithChange = (value) => {
    setTaggedWith(value);
    baseHelper.setUrl(location, navigate, { list_search: value });
    const listSearch = baseHelper.setQueryParams(location, { list_search: value });
    navigate(`${location.pathname}?${listSearch}`);
    const filteredObj = baseHelper.queryParamsFromLocation(location);
    setDataToFetch({ ...dataToFetch, ...filteredObj });
  };

  return (
    <>
      <FormLayout>
        <Select
          label={cms("provider.label.showAll")}
          value={selectedFilter || ""}
          placeholder={cms("common.placeholder.select")}
          onChange={handleSelectChange}
          options={filterOptions}
        />
        {(selectedFilter && (
          <TextField label={cms("common.label.like")} value={taggedWith} onChange={handleTaggedWithChange} />
        )) ||
          null}
      </FormLayout>
    </>
  );
};
MoreFilters.defaultProps = {
  setTaggedWith: () => {},
  taggedWith: "",
  setSelectedFilter: () => {},
  selectedFilter: "",
};

MoreFilters.propTypes = {
  setTaggedWith: PropsType.func,
  taggedWith: PropsType.string,
  setSelectedFilter: PropsType.func,
  selectedFilter: PropsType.string,
};
export default MoreFilters;
